import { render, staticRenderFns } from "./categoryView.component.vue?vue&type=template&id=216accf9&scoped=true&"
import script from "./categoryView.component.vue?vue&type=script&lang=js&"
export * from "./categoryView.component.vue?vue&type=script&lang=js&"
import style0 from "./categoryView.component.vue?vue&type=style&index=0&id=216accf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216accf9",
  null
  
)

export default component.exports